import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MultiSelectModule } from "primeng/multiselect";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DropdownModule } from "primeng/dropdown";
import { ChoiceListItemSelectorComponent } from "ng/src/app/choice-lists/choice-list-item-selector.component";
import { AutoCompleteModule } from "primeng/autocomplete";
import { ChoicelistCopierComponent } from "ng/src/app/choice-lists/choicelist-copier.component";
import { LogModule } from "ng/src/app/logs/log.module";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { MessageModule } from "primeng/message";
import { ChoiceListSelectorComponent } from "ng/src/app/choice-lists/choice-list-selector.component";

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		MultiSelectModule,
		ReactiveFormsModule,
		DropdownModule,
		AutoCompleteModule,
		DropdownModule,
		LogModule,
		ButtonModule,
		DialogModule,
		MessageModule
	],
	declarations: [
		ChoicelistCopierComponent,
		ChoiceListItemSelectorComponent,
		ChoiceListSelectorComponent
	],
	exports: [
		ChoiceListItemSelectorComponent,
		ChoicelistCopierComponent,
		ChoiceListSelectorComponent
	]
})
export class ChoiceListModule {}